<template>
  <div class="user-preview user-preview-full-bg">
    <div class="content detail-content">
      <div class="content-inner single-column">
        <div
          class="main-content mt25"
          :class="isShowComment ? 'pega-cursor-pen-only-id' : ''"
          data-test="preview-job"
        >
          <main>
            <preview-job-header
              :company-name="jobInfo.companyName"
              :job-name="jobInfo.name"
              :employment-status="jobInfo.employmentStatus"
              :salary-map="jobInfo.salaryMap"
              :overtime-work-hours="jobInfo.overtimeWorkHours"
              :entry-form-type="jobInfo.entryFormType"
              :comment-highlights="getJobHeaderCommentHighlights"
              :is-show-comment="isShowComment"
              :can-casual-interview="jobInfo.canCasualInterview"
              :is-show-text-count="isShowTextCount"
              :is-client-job="isClientJob"
              :is-salary-display="jobInfo.isSalaryDisplay"
              v-on="$listeners"
            />
            <nav class="detail-local-nav min_nav">
              <ul>
                <li class="current tab-2">
                  <strong>募集情報</strong>
                </li>
              </ul>
            </nav>
            <preview-job-main-article
              :main-photo-id="jobInfo.mainPhotoId"
              :job-name="jobInfo.name.value"
              :job-pr-icons="jobInfo.prIcons"
              :main-title="jobInfo.mainTitle"
              :main-body="jobInfo.mainBody"
              :comment-highlights="getMainCommentHighlights"
              :is-show-comment="isShowComment"
              :is-show-text-count="isShowTextCount"
              v-on="$listeners"
            />
            <section class="bigarea bosyuarea mod-job-content">
              <header class="h3_title">
                <h3>募集要項</h3>
                <p
                  class="lead"
                  data-test="job-preview-contents-header"
                >
                  {{ jobInfo.companyName }}が募集している求人の詳細です。
                </p>
              </header>
              <div class="box clearfix">
                <h4 class="recr-bg">
                  募集背景
                </h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.background"
                    tag="p"
                    :text="jobInfo.background"
                    column-name="募集背景"
                    :comment-highlights="getCommentHighlights(targetIdMap.background)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4 class="job-cont">
                  仕事内容
                </h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.jobDescription"
                    tag="h6"
                    :text="jobInfo.description"
                    column-name="仕事内容"
                    :comment-highlights="getCommentHighlights(targetIdMap.jobDescription)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.projectsDealing.value"
                    :id="targetIdMap.projectsDealing"
                    tag="p"
                    :text="jobInfo.projectsDealing"
                    title="案件例"
                    :is-engineer="true"
                    :comment-highlights="getCommentHighlights(targetIdMap.projectsDealing)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.commodity.value"
                    :id="targetIdMap.commodity"
                    tag="p"
                    :text="jobInfo.commodity"
                    title="手がける商品・サービス"
                    :comment-highlights="getCommentHighlights(targetIdMap.commodity)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.scopeJob.value"
                    :id="targetIdMap.scopeJob"
                    tag="p"
                    :text="jobInfo.scopeJob"
                    title="開発環境・業務範囲"
                    :is-engineer="true"
                    :comment-highlights="getCommentHighlights(targetIdMap.scopeJob)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.salesStyle.value"
                    :id="targetIdMap.salesStyle"
                    tag="p"
                    :text="jobInfo.salesStyle"
                    title="営業スタイル"
                    :is-sales="true"
                    :comment-highlights="getCommentHighlights(targetIdMap.salesStyle)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.merchandiseDeal.value"
                    :id="targetIdMap.merchandiseDeal"
                    tag="p"
                    :text="jobInfo.merchandiseDeal"
                    title="扱う商材"
                    :is-sales="true"
                    :comment-highlights="getCommentHighlights(targetIdMap.merchandiseDeal)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="showAttentionPoint1"
                    :id="targetIdMap.attentionPoint1"
                    tag="p"
                    :text="jobInfo.attentionPointBody1"
                    title="注目"
                    column-name="注目ポイント１"
                    :caption="jobInfo.attentionPointCaption1"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.attentionPoint1)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="showAttentionPoint2"
                    :id="targetIdMap.attentionPoint2"
                    tag="p"
                    :text="jobInfo.attentionPointBody2"
                    title="注目"
                    column-name="注目ポイント２"
                    :caption="jobInfo.attentionPointCaption2"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.attentionPoint2)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content-timeschedule
                    v-if="showTimeSchedule"
                    :id="targetIdMap.timeSchedule"
                    :time-schedule-title="jobInfo.timeScheduleTitle"
                    :time-schedules="jobInfo.timeSchedules"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.timeSchedule)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div
                v-if="showPassChild"
                class="box clearfix"
                data-test="pass-child"
              >
                <h4>身に付くスキル<br>・キャリアパス</h4>
                <div class="_box_main">
                  <preview-job-content
                    v-if="jobInfo.careerPath.value"
                    :id="targetIdMap.careerPath"
                    tag="h6"
                    :text="jobInfo.careerPath"
                    column-name="身に付くスキル・キャリアパス"
                    :comment-highlights="getCommentHighlights(targetIdMap.careerPath)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.supportAfterJoin.value"
                    :id="targetIdMap.supportAfterJoin"
                    tag="p"
                    :text="jobInfo.supportAfterJoin"
                    title="入社後の成長サポート"
                    :comment-highlights="getCommentHighlights(targetIdMap.supportAfterJoin)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>応募資格</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.requiredSkill"
                    tag="h6"
                    :text="jobInfo.requiredSkill"
                    column-name="応募資格"
                    :comment-highlights="getCommentHighlights(targetIdMap.requiredSkill)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.welcomeSkill.value"
                    :id="targetIdMap.welcomeSkill"
                    tag="p"
                    :text="jobInfo.welcomeSkill"
                    title="歓迎する経験・スキル"
                    :comment-highlights="getCommentHighlights(targetIdMap.welcomeSkill)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.recruitExample.value"
                    :id="targetIdMap.recruitExample"
                    tag="p"
                    :text="jobInfo.recruitExample"
                    title="過去の採用例"
                    :comment-highlights="getCommentHighlights(targetIdMap.recruitExample)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="showSuitablePerson"
                    :id="targetIdMap.suitablePerson"
                    tag="p"
                    title="この仕事の向き・不向き"
                    :suitable-person="{'suitableForThisJob':jobInfo.suitableForThisJob,'notSuitableForThisJob':jobInfo.notSuitableForThisJob}"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.suitablePerson)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>雇用形態</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.employmentStatus"
                    tag="p"
                    :text="{ value :employmentStatusText }"
                    class="margin-bottom-0"
                    :has-remarks="hasTrialPeriodRemarksInEmploymentStatus"
                    :comment-highlights="getCommentHighlights(targetIdMap.employmentStatus)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="isClientJob || jobInfo.trialPeriodText"
                    :id="targetIdMap.trialPeriodText"
                    tag="p"
                    title="試用期間"
                    :text="getTrialPeriodText"
                    class="margin-bottom-0"
                    :has-remarks="isShowTrialPeriodEmploymentStatusRemarks"
                    :comment-highlights="getCommentHighlights(targetIdMap.trialPeriodText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="isShowTrialPeriodEmploymentStatusRemarks"
                    :id="targetIdMap.trialPeriodEmploymentStatusRemarks"
                    tag="p"
                    column-name="試用期間雇用形態備考"
                    :text="jobInfo.trialPeriodEmploymentStatusRemarks"
                    :comment-highlights="getCommentHighlights(targetIdMap.trialPeriodEmploymentStatusRemarks)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>想定給与</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.salary"
                    tag="h6"
                    column-name="想定給与"
                    :text="jobInfo.salary"
                    :comment-highlights="getCommentHighlights(targetIdMap.salary)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.deemedOvertimeHoursText"
                    :id="targetIdMap.deemedOvertimeHoursText"
                    tag="p"
                    :text="getDeemedOvertimeHoursText"
                    title="固定残業代について"
                    :comment-highlights="getCommentHighlights(targetIdMap.deemedOvertimeHoursText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.salaryExample.value"
                    :id="targetIdMap.salaryExample"
                    tag="p"
                    :text="jobInfo.salaryExample"
                    title="実際の給与例"
                    :comment-highlights="getCommentHighlights(targetIdMap.salaryExample)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.bonus.value"
                    :id="targetIdMap.bonus"
                    tag="p"
                    :text="jobInfo.bonus"
                    title="賞与について"
                    :comment-highlights="getCommentHighlights(targetIdMap.bonus)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="!!jobInfo.salaryByWorkplaceAddressListText.value"
                    :id="targetIdMap.salaryByWorkplaceAddressListText"
                    tag="p"
                    title="勤務地別給与"
                    :text="jobInfo.salaryByWorkplaceAddressListText"
                    :comment-highlights="getCommentHighlights(targetIdMap.salaryByWorkplaceAddressListText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>勤務時間</h4>
                <div class="_box_main">
                  <preview-job-content
                    v-if="jobInfo.workSystemText"
                    :id="targetIdMap.workSystemText"
                    tag="p"
                    :text="getWorkSystemText"
                    class="margin-bottom-0"
                    :has-remarks="!!jobInfo.officeHours.value"
                    :comment-highlights="getCommentHighlights(targetIdMap.workSystemText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    :id="targetIdMap.officeHours"
                    tag="p"
                    column-name="勤務時間"
                    :text="jobInfo.officeHours"
                    :comment-highlights="getCommentHighlights(targetIdMap.officeHours)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.overTime.value"
                    :id="targetIdMap.overTime"
                    tag="p"
                    :text="jobInfo.overTime"
                    title="残業について"
                    :comment-highlights="getCommentHighlights(targetIdMap.overTime)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>勤務地</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.jobPlace"
                    tag="h6"
                    column-name="勤務地"
                    :text="jobInfo.place"
                    :comment-highlights="getCommentHighlights(targetIdMap.jobPlace)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.transportation.value"
                    :id="targetIdMap.transportation"
                    tag="p"
                    :text="jobInfo.transportation"
                    title="交通・詳細"
                    :comment-highlights="getCommentHighlights(targetIdMap.transportation)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-places
                    v-if="!jobInfo.isBulkAddressRegistration"
                    :id="targetIdMap.places"
                    tag="p"
                    :places="jobInfo.placeAreaList"
                    title="勤務地エリア"
                    :comment-highlights="getCommentHighlights(targetIdMap.places)"
                    :is-show-comment="isShowComment"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="isShowWorkplaceAddressListText"
                    :id="targetIdMap.workplaceAddressListText"
                    tag="p"
                    :text="jobInfo.workplaceAddressListText"
                    title="勤務地一覧"
                    :comment-highlights="getCommentHighlights(targetIdMap.workplaceAddressListText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.workstyle"
                    :id="targetIdMap.workstyle"
                    tag="p"
                    :text="getWorkstyleText"
                    class="margin-bottom-0"
                    title="働き方"
                    :is-workstyle="true"
                    :has-remarks="!!jobInfo.workstyleNote.value"
                    :comment-highlights="getCommentHighlights(targetIdMap.workstyle)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.workstyle && jobInfo.workstyleNote.value"
                    :id="targetIdMap.workstyleNote"
                    tag="p"
                    column-name="働き方について備考"
                    :text="jobInfo.workstyleNote"
                    :comment-highlights="getCommentHighlights(targetIdMap.workstyleNote)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>休日休暇</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.vacation"
                    tag="p"
                    column-name="休日休暇"
                    :text="jobInfo.vacation"
                    :comment-highlights="getCommentHighlights(targetIdMap.vacation)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div class="box clearfix">
                <h4>待遇・福利厚生</h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.jobCondition"
                    tag="h6"
                    column-name="待遇・福利厚生"
                    :text="jobInfo.condition"
                    :comment-highlights="getCommentHighlights(targetIdMap.jobCondition)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="isClientJob || jobInfo.smokingRuleText"
                    :id="targetIdMap.smokingRuleText"
                    tag="p"
                    :text="getSmokingRuleText"
                    title="喫煙環境"
                    :comment-highlights="getCommentHighlights(targetIdMap.smokingRuleText)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-content
                    v-if="jobInfo.maternityChildcare.value"
                    :id="targetIdMap.maternityChildcare"
                    tag="p"
                    :text="jobInfo.maternityChildcare"
                    title="産休・育休取得状況"
                    :comment-highlights="getCommentHighlights(targetIdMap.maternityChildcare)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
            </section>
            <section class="mod-button-holder new_area button-holder">
              <ul
                class="normal-btn"
                :class="[{'non-casual-interview':!jobInfo.canCasualInterview}]"
              >
                <li
                  v-if="jobInfo.canCasualInterview"
                  class="form_btn"
                  data-test="casual-interview-button"
                >
                  <a class="mod-button casual-interview-button js-over pb4 pr3 pl3 pt7">
                    <img
                      :src="`${userEndPoint}/common/img/module/interview.png`"
                      class="casual-interview-icon"
                    >
                    <span class="align-middle line-height-init">話を聞きたい</span>
                  </a>
                </li>
                <li class="form_btn">
                  <!-- シンプル応募 -->
                  <a
                    v-if="isSimpleTypeEntryFrom"
                    class="mod-button entry-button simple-button pb7 pr3 pl3 pt4"
                    style="opacity:0.99;"
                    data-test="button-simple"
                  >
                    <span class="entry-type-simple-text mr5 mt2 line-height-init">自己PR不要！</span><br>
                    <span
                      style="vertical-align:middle;"
                      class="simple-txt align-top line-height-init"
                    >応募フォームへ</span>
                  </a>
                  <!-- ライト応募 -->
                  <a
                    v-else-if="isLightTypeEntryForm"
                    class="mod-button entry-button light-button pb7 pr3 pl3 pt4"
                    style="opacity:0.99;"
                    data-test="button-light"
                  >
                    <span class="entry-type-light-text mr5 line-height-init">自己PRと職歴不要！</span><br>
                    <span
                      style="vertical-align:middle;"
                      class="light-txt align-top line-height-init"
                    >応募フォームへ</span>
                  </a>
                  <!-- 通常応募 -->
                  <a
                    v-else
                    class="mod-button entry-button js-over pb4 pr3 pl3 pt7"
                    style="opacity:0.99;"
                    data-test="button-normal"
                  >応募フォームへ</a>
                </li>
                <li class="detail-bookmark-button">
                  <img
                    :src="`${userEndPoint}/common/img/module/bookmark_star_off.png`"
                    class="book-mark is-inactive"
                  >
                </li>
              </ul>
              <p class="end_date_area">
                掲載終了予定日：yyyy.mm.dd
              </p>
            </section>
            <section
              v-if="containsAnyOfficeReports"
              class="bigarea sugaoarea mod-job-sugao"
              data-test="office-reports"
            >
              <header class="h3_title">
                <h3>もっと知りたい！会社の素顔</h3>
                <p class="lead">
                  募集要項だけでは伝わらない 会社の魅力をお伝えします。
                </p>
              </header>
              <div
                v-if="showFreeArticle"
                class="box clearfix"
                data-test="free-article"
              >
                <h4
                  class="_topics"
                  data-test="free-article-title"
                >
                  {{ freeArticleTitle }}
                </h4>
                <div class="_box_main">
                  <preview-job-company-topic
                    v-if="companyInterview.topicsTitle1.value"
                    index="1"
                    :company-topic="getCompanyTopic1"
                    :column-name="freeArticleTitle + '1'"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.message.prefix,1)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                  <preview-job-company-topic
                    v-if="companyInterview.topicsTitle2.value"
                    index="2"
                    :company-topic="getCompanyTopic2"
                    :column-name="freeArticleTitle + '2'"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.message.prefix,2)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <div
                v-if="companyInterview.interviewBody.value"
                class="box clearfix"
                data-test="interview-body"
              >
                <h4 class="_from">
                  取材担当者より
                </h4>
                <div class="_box_main">
                  <preview-job-content
                    :id="targetIdMap.interviewBody"
                    tag="p"
                    :text="companyInterview.interviewBody"
                    column-name="取材担当者より"
                    :comment-highlights="getAnyCommentHighlights(targetIdMap.interviewBody)"
                    :is-show-comment="isShowComment"
                    :is-show-text-count="isShowTextCount"
                    v-on="$listeners"
                  />
                </div>
              </div>
              <preview-job-company-photos
                v-if="showPhotoArea"
                :id="targetIdMap.sugaoPhoto"
                :caption-id="targetIdMap.sugaoPhotoCaption"
                :photos="getPhotos"
                :comment-highlights="getAnyCommentHighlights(targetIdMap.sugaoPhoto)"
                :is-show-comment="isShowComment"
                :is-show-text-count="isShowTextCount"
                v-on="$listeners"
              />
            </section>
            <section class="bigarea kigyogaiyo mod-job-detail mod-company-info">
              <header class="h3_title">
                <h3>会社概要</h3>
                <p
                  class="lead"
                  data-test="company-detail-header"
                >
                  {{ companyInfo.companyName }}の会社概要です。
                </p>
              </header>
              <div class="mod-job-info mt10 mb10">
                <preview-job-company-detail
                  :id="targetIdMap.companyDescription"
                  title="事業内容"
                  :text="companyInfo.companyDescription"
                  :comment-highlights="getCommentHighlights(targetIdMap.companyDescription)"
                  :is-show-comment="isShowComment"
                  :is-show-text-count="isShowTextCount"
                  :is-first-child="true"
                  v-on="$listeners"
                />
                <preview-job-company-detail
                  v-if="companyInfo.mediaCoverage.value"
                  :id="targetIdMap.mediaCoverage"
                  title="事業・サービスのメディア掲載実績・受賞歴"
                  :text="companyInfo.mediaCoverage"
                  :comment-highlights="getCommentHighlights(targetIdMap.mediaCoverage)"
                  :is-show-comment="isShowComment"
                  :is-show-text-count="isShowTextCount"
                  v-on="$listeners"
                />
                <preview-job-company-detail
                  v-if="companyInfo.mainClient.value"
                  :id="targetIdMap.mainClient"
                  title="主要取引先"
                  :text="companyInfo.mainClient"
                  :comment-highlights="getCommentHighlights(targetIdMap.mainClient)"
                  :is-show-comment="isShowComment"
                  :is-show-text-count="isShowTextCount"
                  v-on="$listeners"
                />
                <preview-job-company-detail-others
                  :company-info="getCompanyOtherInfo"
                  :comment-highlights="getCompanyOtherCommentHighlights"
                  :is-show-comment="isShowComment"
                  :is-show-text-count="isShowTextCount"
                  v-on="$listeners"
                />
              </div>
            </section>
            <section class="bigarea aboutoubo mod-choice-process">
              <header class="h3_title">
                <h3>応募について</h3>
                <p class="lead">
                  選考プロセスをはじめ、応募時に必要な情報や連絡先を確認できます。
                </p>
              </header>
              <preview-job-process
                :processes="aboutApply.entryProcess.processes"
                :process-detail="aboutApply.entryProcess.processDetail"
                :comment-highlights="getAnyCommentHighlights(targetIdMap.process)"
                :is-show-comment="isShowComment"
                :is-show-text-count="isShowTextCount"
                :is-client-job="isClientJob"
                v-on="$listeners"
              />
              <preview-job-process-others
                :company-name="companyInfo.companyName"
                :about-apply="getProcessOtherInfo"
                :comment-highlights="getProcessOtherCommentHighlights"
                :is-show-comment="isShowComment"
                :is-show-text-count="isShowTextCount"
                v-on="$listeners"
              />
            </section>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobHeader from '@/components/molecules/PreviewJobHeader'
import PreviewJobMainArticle from '@/components/molecules/PreviewJobMainArticle'
import PreviewJobContent from '@/components/molecules/PreviewJobContent'
import PreviewJobContentTimeschedule from '@/components/molecules/PreviewJobContentTimeschedule'
import PreviewJobPlaces from '@/components/molecules/PreviewJobPlaces'
import PreviewJobCompanyTopic from '@/components/molecules/PreviewJobCompanyTopic'
import PreviewJobCompanyPhotos from '@/components/molecules/PreviewJobCompanyPhotos'
import PreviewJobCompanyDetail from '@/components/molecules/PreviewJobCompanyDetail'
import PreviewJobCompanyDetailOthers from '@/components/molecules/PreviewJobCompanyDetailOthers'
import PreviewJobProcess from '@/components/molecules/PreviewJobProcess'
import PreviewJobProcessOthers from '@/components/molecules/PreviewJobProcessOthers'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import jobPreviewVisibilityCommon from '@/lib/jobPreviewVisibilityCommon'

export default {
  components: {
    PreviewJobHeader,
    PreviewJobMainArticle,
    PreviewJobContent,
    PreviewJobContentTimeschedule,
    PreviewJobPlaces,
    PreviewJobCompanyTopic,
    PreviewJobCompanyPhotos,
    PreviewJobCompanyDetail,
    PreviewJobCompanyDetailOthers,
    PreviewJobProcessOthers,
    PreviewJobProcess
  },
  mixins: [jobPreviewCommon, jobPreviewVisibilityCommon],
  props: {
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    },
    jobInfo: {
      type: Object,
      required: true
    },
    companyInterview: {
      type: Object,
      required: true
    },
    companyInfo: {
      type: Object,
      required: true
    },
    aboutApply: {
      type: Object,
      required: true
    },
    places: {
      type: Array,
      default: () => []
    },
    isClientJob: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowTrialPeriodEmploymentStatusRemarks () {
      return this.isClientJob
        ? this.jobInfo.isShowTrialPeriodEmploymentStatusRemarks
        : !!this.jobInfo.trialPeriodEmploymentStatusRemarks.value
    },
    isShowWorkplaceAddressListText () {
      return !this.jobInfo.isOnlyFullRemote &&
        this.jobInfo.isBulkAddressRegistration &&
        (this.isClientJob || // クライアント制作職種の場合は必須表示
        !!this.jobInfo.workplaceAddressListText.value)
    },
    isSimpleTypeEntryFrom () {
      return this.jobInfo.entryFormType === this.entryFormTypeMap.simple
    },
    isLightTypeEntryForm () {
      return this.jobInfo.entryFormType === this.entryFormTypeMap.light
    },
    getCompanyTopic1 () {
      return {
        text: this.companyInterview.topicsBody1,
        caption: this.companyInterview.topicsTitle1,
        photo: {
          id: this.companyInterview.topicsPhotoId1,
          caption: this.companyInterview.topicsPhotoCaption1
        }
      }
    },
    getCompanyTopic2 () {
      return {
        text: this.companyInterview.topicsBody2,
        caption: this.companyInterview.topicsTitle2,
        photo: {
          id: this.companyInterview.topicsPhotoId2,
          caption: this.companyInterview.topicsPhotoCaption2
        }
      }
    },
    getPhotos () {
      return [
        {
          id: this.companyInterview.sugaoPhoto1,
          caption: this.companyInterview.sugaoPhotoCaption1
        },
        {
          id: this.companyInterview.sugaoPhoto2,
          caption: this.companyInterview.sugaoPhotoCaption2
        },
        {
          id: this.companyInterview.sugaoPhoto3,
          caption: this.companyInterview.sugaoPhotoCaption3
        }
      ].filter(i => i.id) // idがないものは除く
    },
    getCompanyOtherInfo () {
      return {
        established: this.companyInfo.established,
        employeesNum: this.companyInfo.employeesNum,
        averageAge: this.companyInfo.averageAge,
        employeesSexRatio: this.companyInfo.employeesSexRatio,
        middleEnterRatio: this.companyInfo.middleEnterRatio,
        capital: this.companyInfo.capital,
        salesAmount: this.companyInfo.salesAmount,
        presidentName: this.companyInfo.presidentName,
        presidentHistory: this.companyInfo.presidentHistory
      }
    },
    getProcessOtherInfo () {
      return {
        homepageUrl: this.aboutApply.homepageUrl,
        zipcode: this.aboutApply.zipcode,
        address: this.aboutApply.address,
        contactDepartment: this.aboutApply.contactDepartment,
        tel: this.aboutApply.tel,
        contactEmail: this.aboutApply.contactEmail,
        links: this.aboutApply.links
      }
    },
    getJobHeaderCommentHighlights () {
      const targets = [
        this.targetIdMap.jobName,
        this.targetIdMap.salaryMap,
        this.targetIdMap.overtimeWorkHours]
      return this.commentHighlights.filter(commentHighlight => targets.includes(commentHighlight.target))
    },
    getMainCommentHighlights () {
      const targets = [
        this.targetIdMap.mainTitle,
        this.targetIdMap.mainBody,
        this.targetIdMap.mainPhoto,
        ...Object.values(this.targetIdMap.jobPrIcons)]
      return this.getArrayCommentHighlights(targets)
    },
    getCompanyOtherCommentHighlights () {
      const targets = [
        this.targetIdMap.established,
        this.targetIdMap.employeesNum,
        this.targetIdMap.averageAge,
        this.targetIdMap.employeesSexRatio,
        this.targetIdMap.middleEnterRatio,
        this.targetIdMap.capital,
        this.targetIdMap.salesAmount,
        this.targetIdMap.presidentName,
        this.targetIdMap.presidentHistory
      ]
      return this.getArrayCommentHighlights(targets)
    },
    getProcessOtherCommentHighlights () {
      const targets = [
        this.targetIdMap.homepageUrl,
        this.targetIdMap.address,
        ...this.targetIdMap.links
      ]
      return this.getArrayCommentHighlights(targets)
    },
    getWorkstyleText () {
      return { value: this.jobInfo.workstyle }
    },
    getDeemedOvertimeHoursText () {
      return { value: this.jobInfo.deemedOvertimeHoursText }
    },
    getTrialPeriodText () {
      return { value: this.jobInfo.trialPeriodText }
    },
    getWorkSystemText () {
      return { value: this.jobInfo.workSystemText }
    },
    getSmokingRuleText () {
      return { value: this.jobInfo.smokingRuleText }
    },
    hasTrialPeriodRemarksInEmploymentStatus () {
      // 「試用期間」が設定なし、「試用期間の雇用形態備考」が設定ありの場合のみ、
      // 「試用期間の雇用形態備考」を「雇用形態」の下に表示する為、判定した結果を返す
      return !this.jobInfo.trialPeriodText && !!this.jobInfo.trialPeriodEmploymentStatusRemarks.value
    }
  },
  methods: {
    getCommentHighlights (target) {
      return this.commentHighlights.filter(commentHighlight => commentHighlight.target === target)
    },
    getAnyCommentHighlights (target, index = null) {
      const commentHighlights = this.commentHighlights.filter(commentHighlight => commentHighlight.target.indexOf(target) > -1)
      if (index !== null) {
        return commentHighlights.filter(commentHighlight => commentHighlight.target.lastIndexOf(index) > -1)
      }
      return commentHighlights
    },
    getArrayCommentHighlights (targets) {
      return this.commentHighlights.filter(commentHighlight => targets.includes(commentHighlight.target))
    }
  }
}
</script>
